/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2022. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */ /*
 * Licensed Materials - Property of IBM
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'VerifyIdentity_Title',
    defaultMessage: 'Verify Your Identity - Questions',
  },
  signUp: {
    id: 'VerifyIdentity_SignUp',
    defaultMessage: 'Sign Up',
  },
  validationMessage: {
    id: 'VerifyIdentity_ValidationMessage',
    defaultMessage: '  Please enter a valid value for',
  },
});
